import * as _PortOne from '@portone/browser-sdk/v2';

type portOneConfig = {
  storeId: string;
  identityVerificationId: string;
  channelKey: string;
  windowType: { pc: _PortOne.Entity.WindowType.POPUP; mobile: _PortOne.Entity.WindowType.REDIRECTION };
  redirectUrl: string;
};
const RequestIdentityVerification = (config: portOneConfig) => _PortOne.requestIdentityVerification(config);

const PortOne = {
  TYPE: _PortOne,
  RequestIdentityVerification,
};

export { PortOne };
export type { portOneConfig };
